
import {initWebComponent} from "@/helpers/web-component-helper";
import DOMPurify from 'dompurify';
import {escapeOutput} from "@/helpers/output-helper.js";

export class LayerInfoInfoTypeTextComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const childKey = this.getAttribute('data-child-key')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const recordIndex = this.getAttribute('data-record-index')
        const attributeIndex = this.getAttribute('data-attribute-index')

        let attributeItem
        if(recordIndex === null) {
            attributeItem = window.attributeItems[featureKey][featureInfoKey].attributeItems[key]
        } else {
            if(childKey) {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key][childKey]
            } else {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key]
            }
        }

        if(attributeIndex) {
            attributeItem = attributeItem[attributeIndex]
        }

        if(attributeItem?.Value) {
            attributeItem.Value = DOMPurify.sanitize(attributeItem.Value)
        }

        const template = document.createElement('template');

        if(attributeItem.Value) {
            attributeItem.Value = DOMPurify.sanitize(attributeItem.Value)
        }

        if(attributeItem.DomainList) {
            if(attributeItem.DomainList.domain_list_items) {
                const domainListItem = attributeItem.DomainList.domain_list_items.find(domainListItem => String(domainListItem.Value) === String(attributeItem.Value));
                if (domainListItem) {
                    template.innerHTML = domainListItem.Name
                } else {
                    template.innerHTML = attributeItem.Value;
                }
            }
        } else {
            let innerHTML = ''
            if(attributeItem.Prefix) {
                innerHTML += attributeItem.Prefix
            }

            innerHTML += attributeItem.Value

            if(attributeItem.Suffix) {
                innerHTML += attributeItem.Suffix
            }

            template.innerHTML = innerHTML
        }

        let isHtml = false
        if(attributeItem.Type === 404) {
            isHtml = true
        }

        initWebComponent(this, template, isHtml)
    }
}

